import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReasonService {

  constructor(private http: HttpClient,
    private session: SessionService,) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_ResignationReasonMaster_Insert(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ResignationReasonMaster_Insert/Update`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ESS_ResignationReasonMaster(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ResignationReasonMaster/Load`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
